import BinderView from './BinderView/BinderView';
import Details from './Details/Details';
import Files from './Files/Files';
import BinderSetup from './BinderSetup/BinderSetup';
import UsersConfiguration from './Users/UsersConfiguration';

export {
    BinderView,
    Details,
    Files,
    BinderSetup,
    UsersConfiguration
};
